import createLucideIcon from '../createLucideIcon';

const Layers = createLucideIcon('Layers', [
  ['polygon', { points: '12 2 2 7 12 12 22 7 12 2', key: '1b0ttc' }],
  ['polyline', { points: '2 17 12 22 22 17', key: 'imjtdl' }],
  ['polyline', { points: '2 12 12 17 22 12', key: '5dexcv' }],
]);

export default Layers;
